import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=bc5b96fc&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=bc5b96fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5b96fc",
  null
  
)

export default component.exports